const buildVCardUrl = () => {
  const id = new URL(window.location.href).searchParams.get('id');
  const cardString = `/MemberDirectoryDetailPage/vcard/${id}`;

  return cardString;
};

export default buildVCardUrl;
